import { iframeAddress } from '@common';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState = iframeAddress;
const avatarUrlSlice = createSlice({
  name: 'avatarUrl',
  initialState: '',
  reducers: {
    setIframeAddress: (_, action: PayloadAction<string>) => action.payload,
  },
});

export const { setIframeAddress } = avatarUrlSlice.actions;
export const avatarUrlReducer = avatarUrlSlice.reducer;
